<template>
  <div class="ine-form__form-wrapper">
    <form @submit.prevent="validateFields" class="ine-form__form">
      <Title
        header="Two Factor Confirmation"
        tagline="<span style='font-size: 1rem'>You should receive a code from us shortly to your preferred contact
            method (phone or email).
            <br />
            Please enter that code in the form below to continue logging in.</span>"
      />
      <Errors :errors="errors.messages" />
      <div
        v-for="(field, key) in fields"
        v-show="field.type"
        :key="`field-${key}`"
        class="ine-form__form-group"
      >
        <input
          v-if="field.type"
          :type="field.type"
          :class="[
            'ine-form__form-control',
            errors.fields.includes(key) && 'ine-form__form-control--error',
          ]"
          @focus="clearErrors"
          :placeholder="field.placeholder"
          :autocomplete="field.autocomplete"
          v-model="field.value"
        />
      </div>
      <div class="ine-form__actions">
        <SubmitBtn title="Submit" iconName="security" :isLoading="isLoading" />
      </div>
      <div v-show="!isLoading" class="login__additional-links">
        <button
          @click.prevent="$emit('resend-mfa-code')"
          class="ine-form__link"
        >
          Resend Code
        </button>
        <button
          @click.prevent="$emit('cancel-login')"
          class="ine-form__link ine-form__homepage-link"
        >
          Back to Homepage
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import Errors from '@/components/forms/elements/Errors.vue'
import SubmitBtn from '@/components/forms/elements/SubmitBtn.vue'

export default {
  name: 'TwoFactorForm',
  components: {
    Title,
    Errors,
    SubmitBtn,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        'mfa code': {
          type: 'text',
          rules: ['presence'],
          placeholder: 'MFA Code',
          value: '',
          autocomplete: 'one-time-code',
        },
      },
    }
  },
  methods: {
    validateFields() {
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        const payload = {
          code: fields['mfa code'].value,
        }
        this.$emit('submit-form', payload)
      }
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
}
</script>
